export default __webpack_public_path__ + "static/media/1.00c8b0d9.svg";